<template>
    <button 
        class="btn"
        type="button"
        :class="{ danger, primary }" 
        :disabled="disabled"
        @click="click"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        to: { default: null },
        danger: { type: Boolean, default: false },
        primary: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
    methods: {
        click() {
            if (this.to) {
                this.$router.push(this.to);
            }
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss" scoped>
        .btn {
            width: 182px;
            color: #fff;
            border-radius: 4px;
            text-align: center;
            padding: 12px 5px;
            // margin: 20px 0;
            outline: none;
            border: none;
            cursor: pointer;
            font-family: "Futura PT", sans-serif;
            font-size: 16px;
            color: #FFFFFF;

            &.primary {
                background-color: #3874E0;
            }
            &.danger {
                background-color: #D1004A;
            }
            &.disabled {
                background-color: #BAC5CB;
            }
        }
</style>